import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const useUserProfileEditTracking = () => {
  const {track} = useAnalyticsTrack()
  const {domain} = useContext(Context)

  const config = domain.get('config')
  const {ACCOUNT_EDITED, ACCOUNT_EDITED_ERROR} = config.get('tracking').TRACKING_EVENT_NAMES

  const trackError = ({formErrors} = {}) => {
    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        event: ACCOUNT_EDITED_ERROR,
        formErrors
      })
      .then(eventTrackingData => {
        track(eventTrackingData)
      })
  }

  const trackSuccess = ({fields} = {}) => {
    domain
      .get('get_event_tracking_data_use_case')
      .execute({
        event: ACCOUNT_EDITED,
        fields
      })
      .then(eventTrackingData => {
        track(eventTrackingData)
      })
  }
  return {trackError, trackSuccess}
}

export {useUserProfileEditTracking}
